module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.louti),
      expression: "louti"
    }],
    attrs: {
      "id": "loadingToast"
    }
  }, [_c('div', {
    staticClass: "weui-toast"
  }, [_c('p', {
    staticClass: "weui-toast__content"
  }, [_vm._v(_vm._s(_vm.zimu))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9e8e908"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xlouti.vue
// module id = 278
// module chunks = 0